export default "__VITE_ASSET__Cj1oWAzK__"